// eslint-disable-next-line import/prefer-default-export
export const PAYMENT_STATUS = {
  EXPORTED: 'exported',
  EXPORTABLE: 'exportable',
  UPCOMING: 'upcoming',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  REFUNDABLE: 'refundable',
  FAILED: 'failed',
  BLOCKED: 'blocked',
  PAID: 'paid',
};
